export default __webpack_public_path__ + "static/media/Profile.1da9d163.jpeg";